import { ReactNode } from 'react';
import formatMetricValue from '../../../helpers/formatMetricValue';
import { GlobalMetricValueFormat } from '../../../types';
import { Value, ValueLabel } from '../styled';

const getValue = ({
    value, valueLabel, valueFormat,
}: {
    value: number | string | ReactNode;
    valueLabel?: string;
    valueFormat?: GlobalMetricValueFormat
}) => {
    if (typeof value === 'number') {
        return (
            <Value>
                {formatMetricValue(value, valueFormat)}
                {valueLabel ? <ValueLabel>{valueLabel}</ValueLabel> : null}
            </Value>
        );
    }

    if (typeof value === 'string') {
        return (
            <Value>
                {value}
                {valueLabel ? <ValueLabel>{valueLabel}</ValueLabel> : null}
            </Value>
        );
    }

    // Custom React content (e.g. Sales ratio) controls its own layout; do not wrap in <Value>.
    if (valueLabel) {
        return (
            <Value>
                {value}
                <ValueLabel>{valueLabel}</ValueLabel>
            </Value>
        );
    }

    return value;
};

export default getValue;
